import { FC } from 'react';

interface BoldIconProps {
  color?: string;
  size?: string;
  className?: string;
}

export const BoldIcon: FC<BoldIconProps> = ({ color = 'currentColor', size = '16', className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M5 2.29688H9.25C9.80937 2.29708 10.3576 2.45644 10.8301 2.75586C11.3024 3.05527 11.68 3.48269 11.9189 3.98828C12.1579 4.494 12.2483 5.05719 12.1797 5.6123C12.1111 6.16745 11.8862 6.69171 11.5312 7.12402L11.4951 7.16797L11.5449 7.19434C12.1671 7.53729 12.6578 8.07825 12.9395 8.73047C13.221 9.38257 13.2775 10.1099 13.1006 10.7979C12.9236 11.4858 12.5232 12.0958 11.9619 12.5312C11.4006 12.9666 10.7104 13.2028 10 13.2031H5C4.81352 13.2031 4.63479 13.1289 4.50293 12.9971C4.37107 12.8652 4.29688 12.6865 4.29688 12.5V3C4.29688 2.81352 4.37107 2.63479 4.50293 2.50293C4.63479 2.37107 4.81352 2.29688 5 2.29688ZM5.70312 11.7969H10C10.4766 11.7969 10.9335 11.6075 11.2705 11.2705C11.6075 10.9335 11.7969 10.4766 11.7969 10C11.7969 9.52344 11.6075 9.06647 11.2705 8.72949C10.9335 8.39251 10.4766 8.20312 10 8.20312H5.70312V11.7969ZM5.70312 6.79688H9.25C9.66026 6.79688 10.0537 6.63385 10.3438 6.34375C10.6338 6.05365 10.7969 5.66026 10.7969 5.25C10.7969 4.83974 10.6338 4.44635 10.3438 4.15625C10.0537 3.86615 9.66026 3.70312 9.25 3.70312H5.70312V6.79688Z"
      fill={color}
      stroke={color}
      strokeWidth="0.09375"
    />
  </svg>
);
